import { SupplyBasicFeaturePage } from "..";

/** 餐厅供应商主体管理页面。 */
export function RestaurantsPage() {
  return <SupplyBasicFeaturePage kind="restaurants" />;
}
